export default function capitalizeFirstLetter(value) {
    return value ? value.trim()[0].toUpperCase() + value.trim().slice(1) : null;
}